<template>
  <div :class="{head_top_layout_vip : state.headStyle ==1, head_top_layout_novip : state.headStyle ==2}"
       :style="cBackColor">
    <div class="status_layout" :style="cBackColor2">
    </div>
    <div class="head_layout">
      <div class="left_content" v-if="!state.hideBack" @click="onClickLeft"><img class="icon_img"
                                                                                 :src="state.left_icon"></div>
      <div class="center_content" id="center_content" :style="titleStyle">{{ state.title }} <img class="vip_icon"
                                                                                                 v-if="state.showvipicon"
                                                                                                 src="@/../static/setting_vip_icon.png">
      </div>
      <div class="right_content" v-if="state.showRight" @click="onClickRight"><img class="icon_img"
                                                                                   :src="state.right_icon"></div>
    </div>
  </div>
</template>

<script>

import TitleBarStore from '@/components/widgets/TitleBarStore'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanapi'

const TAG = '[TitleBar]'
export default {
  name: 'TitleBar',
  data () {
    return {
      state: TitleBarStore.store.state,
      height: 40,
      showvipicon: false
    }
  },
  methods: {
    onClickLeft () {
      console.log(TAG, 'clickLeft')
      // history.back()
      jsbridge.backOrExit()
    },
    onClickRight () {
      console.log(TAG, 'onClickRight')
      this.$router.push({
        path: '/basic_setting'
      })

      lubanapi.reportseer('AICall_Home_Page_Setting_Button_Click')
      // this.$router.push({
      //   path: '/supplierallback'
      // });
    }
  },
  computed: {
// 计算属性
    titleStyle () {
      return {
        color: this.state.whiteFont ? '#ffffff' : '#444444'
      }
    },
    cBackColor () {
      if (this.state.headStyle) {
        return {}
      } else {
        return {
          background: this.state.backColor
        }
      }

    },
    cBackColor2 () {
      return {
        height: this.height + 'px'
      }
    }
  },
  mounted: function () {
    jsbridge.getStatusBarHeight().then(res => {
      console.log(TAG, 'getStatusBarHeight', res, res.height, document.body.clientWidth)
      if (res.err_msg === 'ok' && res.ret === 0 && res.height > 0) {
        var height = res.height
        var screenwidth = res.screenwidth
        if (screenwidth == undefined || screenwidth == 0) {
          screenwidth = 1080
        }
        if (height > 0 && document.body.clientWidth > 0) {
          this.height = (height * document.body.clientWidth) / screenwidth
        }
      }
    }).catch(err => {
      console.log(TAG, 'getStatusBarHeight', err)
    })
  }
}
</script>
<style scoped>

.head_top_layout {
  width: 100%;
  background: white;
}

.head_top_layout_vip {
  width: 100%;
  /*background: url(../../assets/vip_back.png)  no-repeat right top, #111118;*/
  background: #111118;
  background-size: 30%, 100%;
}

.head_top_layout_novip {
  width: 100%;
  /*background: url(../../assets/vip_back.png)  no-repeat right top, #1259FF;*/
  background: #1259FF;
  background-size: 30%, 100%;
}

.status_layout {
  width: 100%;
}

.head_layout {
  width: 100%;
  height: 3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  align-content: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  /*background: transparent;*/
}

.left_content {
  width: 2rem;
  height: 100%;
}

.right_content {
  width: 2rem;
  height: 100%;
}

.center_content {
  flex: 1;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.25rem;
  font-family: PingFangSC-Medium;
  color: #444444;
  text-align: left;
  padding-left: 0.2rem;
}

.icon_img {
  height: 1.875rem;
  height: 1.875rem;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.vip_icon {
  position: relative;
  width: 3.125rem;
  height: 1.345rem;
  margin-left: 0.2rem;
  top: 50%;
  transform: translateY(-50%);
}

</style>



// WEBPACK FOOTER //
// src/components/widgets/TitleBar.vue